export default function relatedProductsController() {
  const relatedProducts = document.querySelectorAll('.related-products');

  if (relatedProducts.length === 0) {
    return;
  }

  for (const relatedProductsWrapper of relatedProducts) {
    const swiperComponent = relatedProductsWrapper.querySelector('.swiper');

    const swiper = new Swiper(swiperComponent, {
      direction: 'horizontal',
      slidesPerView: 'auto',
      spaceBetween: 10,
      watchSlidesProgress: true,
      mousewheel: true,
    });
  }

  const addToCartButtons = document.querySelectorAll('.related-products__add-to-cart');

  addToCartButtons.forEach((button) => {
    button.addEventListener('click', (event) => {
      // Disable button to prevent multiple clicks
      if (button.classList.contains('loading') || button.getAttribute('aria-disabled') === 'true') {
        return;
      }

      const variantId = button.dataset.variantId;

      button.classList.add('loading');
      button.setAttribute('aria-disabled', 'true');

      addToCart(variantId).finally(() => {
        button.classList.remove('loading');
        button.setAttribute('aria-disabled', 'false');
      });
    });
  });
}
